<template>
  <div data-qa="localtips-div-n6atd">
    <v-card-text data-qa="localtips-card-text-z8m4p">
      <v-row data-qa="localtips-row-mh9jxl">
        <font class="text-h5 pa-4 font-weight-bold" :color="primaryColor">
          {{ config }}
        </font>
      </v-row>
      <template v-if="($t(`localPayments.tip.${config}`) !== `localPayments.tip.${config}`)">
        <v-row
          v-for="(tip,index) in $t(`localPayments.tip.${config}`)"
          :key="index"
          class="pl-4 font-weight-thin" :data-qa="`localtips-row-py859g-${index}`">
          <font>
            {{ $t("common.bullet") }}{{ tip }}
          </font>
        </v-row>
      </template>
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: 'Local-Tips',
  props: {
    config: String
  },
  data () {
    return {
      title: ''
    }
  }
}
</script>
